<template>
    <el-dialog :title="title" :visible.sync="centerDialogVisible" width="50%">
        <el-card class="box-card" shadow="never">
            <!-- <div slot="header" class="clearfix">
                <div style="margin-right: 20px;">
                    <span style="margin-right: 20px;">管理帖子</span>
                    <el-select v-model="value" placeholder="请选择" :disabled="isDisabled">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <span style="margin-right: 20px;">禁言周期</span>
                    <el-select v-model="value1" placeholder="请选择" :disabled="isDisabled">
                        <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div> -->
            <ul class="text">
                <li>
                    <span>发帖人：{{ rowCont.postName }}</span>
                </li>
                <li>                    <span>发帖时间：{{ dateFormat(rowCont.createDate) }}</span>
</li>
                <li>
                    <span>帖子类型：{{ getPostTypeName(rowCont.postType)  }}</span>
                </li>
                <li>
                    <span>点赞数：{{ rowCont.likesCount }}</span>
                    <!-- <span>评论数：xxx</span> -->
                </li>
                <!-- <li>
                    <span>收藏数：xxx</span>
                </li> -->
            </ul>
            <div style="margin-top: 20px;">
                <div style="margin-bottom: 10px;font-size: 20px;font-weight: bold;">原文内容</div>

                <el-row>
                    <el-scrollbar style="height: 300px;line-height: 30px;">
                    {{ rowCont.postContent }}

                </el-scrollbar>
                </el-row>
                
                
            </div>
        </el-card>
        <span v-if="isDisabled == false" slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">返 回</el-button>
            <el-button type="primary" @click="centerDialogVisible = false">确 认</el-button>
        </span>
    </el-dialog>
</template>

<script>
import moment from 'moment'
export default {
    name: 'AdminStaticsPostEdit',

    data() {
        return {
            centerDialogVisible: false,
            options: [{
                value: '1',
                label: '删除'
            }, {
                value: '2',
                label: '删除并禁言作者'
            },],
            options1: [{
                value: '1',
                label: '1周'
            }, {
                value: '2',
                label: '半个月'
            },],
            value: '',
            value1: '',
            rowCont: {},
            title: '',
            isDisabled: false
        };
    },

    mounted() {

    },

    methods: {
        dateFormat(createDate){
           return moment(createDate).format('YYYY-MM-DD HH:mm:ss')
        },
        getPostTypeName(type) {
      switch (type) {
        case 'DAILY_GOSSIP':
          return '日常杂谈';
        case 'EXPERIENCE_SHARING':
          return '经验分享';
        case 'PROBLEM_FEEDBACK':
          return '问题反馈';
          case 'PLATFORM_DIALOGUE':
          return '平台对话';
        default:
          return '其它';
      }
    },
        // 触发弹框
        showEdit(row, title) {
            console.log(row, title);
            this.rowCont = Object.assign({}, row)
            if (title == '管理') {
                this.title = '帖子管理'
                this.isDisabled = false
            } else {
                this.title = '帖子详情'
                this.isDisabled = true
            }
            this.centerDialogVisible = true
        },
    },
};
</script>
<style lang="scss" scoped>
.clearfix {
    display: flex;
}

.text {
    line-height: 40px;

    li {
        width: 60%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            width: 200px;
            white-space: nowrap;
        }

    }
}

.text_cont {
    height: 30%;
    line-height: 30px;
}

::v-deep .el-dialog {
    height: 76vh;
}

::v-deep .el-dialog__body {
    height: 78%;
    padding: 10px 20px;
}

::v-deep .el-input__inner {
    height: 30px;
}

::v-deep .el-input__suffix {
    right: 5px;
    transition: all .3s;
    display: flex;
    align-items: center;
}


.dialog-footer {
    display: flex;
    justify-content: center;

    .el-button {
        width: 50%;
    }
}
</style>